import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import Swal from 'sweetalert2';
import { useUIUtils } from 'hooks/useUIUtils';
import { avisarError, Campo, cargar, dinero, sucursalActual, Tarjeta, tokenOperacion } from '../comun';

const Cobrar = ({ history, match }) => {
    const { id } = match.params;
    const { changeGlobalTitle } = useUIUtils();
    const [orden, setOrden] = useState(null);
    const [formas, setFormas] = useState([]);
    const [cajas, setCajas] = useState([]);
    const [cajeros, setCajeros] = useState([]);
    const [cobros, setCobros] = useState([{ forma_Cobro_Id: '', importe: 0 }]);
    const [cajaId, setCajaId] = useState('');
    const [cajeroId, setCajeroId] = useState('');
    const lista = match.url.replace(/\/cobrar\/.*$/, '');

    useEffect(() => {
        changeGlobalTitle('Cobrar orden', `Orden ${id}`);
        fetchConToken(`pv/PvDocumentos?id=${id}`).then((response) => {
            if (avisarError(response)) return;
            setOrden(response);
            setCajaId(response.caja_Id || '');
            setCajeroId(response.cajero_Id || '');
            setCobros([{ forma_Cobro_Id: '', importe: response.total_Importe || 0 }]);
        });
        cargar('pv/PvFormasCobros/GetList?paginas=0&totalXpagina=200&busqueda=').then(setFormas);
        cargar(`pv/PvCajas/GetList?sucursal_Id=${sucursalActual()}&almacen_id=0&paginas=0&totalXpagina=200&busqueda=`).then(setCajas);
        cargar(`pv/PvCajeros/GetList?usuario_id=0&sucursal_id=${sucursalActual()}&paginas=0&totalXpagina=200`).then(setCajeros);
    }, [changeGlobalTitle, id]);

    function cobrar(event) {
        event.preventDefault();
        fetchConToken('pv/PvDocumentos/CobrarOrden', {
            orden_Id: Number(id),
            sucursal_Id: Number(sucursalActual()),
            caja_Id: Number(cajaId),
            cajero_Id: Number(cajeroId),
            idempotency_Token: tokenOperacion('cobro-orden'),
            cobros: cobros.filter((item) => item.forma_Cobro_Id).map((item) => ({
                tipo: 'C',
                forma_Cobro_Id: Number(item.forma_Cobro_Id),
                importe: Number(item.importe),
                tipo_Cambio: 1,
                moneda: 'MXN'
            }))
        }, 'POST').then((response) => {
            if (avisarError(response)) return;
            Swal.fire('Exito', `Venta ${response.folio || ''} registrada`, 'success');
            history.push(`${lista}/ver/${response.id || id}`);
        }).catch(alertService.error);
    }

    return (
        <div className='container-fluid'>
            <form onSubmit={cobrar}>
                <div className='mb-3'><Link to={lista} className='btn btn-outline-warning'>Regresar</Link></div>
                <Tarjeta titulo={`Cobrar orden ${orden?.folio || id}`}>
                    <p>Total a cubrir: {dinero(orden?.total_Importe)}</p>
                    <div className='row'>
                        <div className='col-md-4'>
                            <Campo label='Caja'>
                                <select className='form-select' required value={cajaId} onChange={({ target }) => setCajaId(target.value)}>
                                    <option value=''>Seleccione</option>
                                    {cajas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                </select>
                            </Campo>
                        </div>
                        <div className='col-md-4'>
                            <Campo label='Cajero'>
                                <select className='form-select' required value={cajeroId} onChange={({ target }) => setCajeroId(target.value)}>
                                    <option value=''>Seleccione</option>
                                    {cajeros.map((item) => <option key={item.id} value={item.id}>Cajero {item.id}</option>)}
                                </select>
                            </Campo>
                        </div>
                    </div>
                    {cobros.map((item, index) => (
                        <div className='row' key={index}>
                            <div className='col-md-6'>
                                <Campo label='Forma de cobro'>
                                    <select className='form-select' value={item.forma_Cobro_Id} onChange={({ target }) => {
                                        const copia = [...cobros];
                                        copia[index] = { ...copia[index], forma_Cobro_Id: target.value };
                                        setCobros(copia);
                                    }}>
                                        <option value=''>Seleccione</option>
                                        {formas.map((forma) => <option key={forma.id} value={forma.id}>{forma.nombre}</option>)}
                                    </select>
                                </Campo>
                            </div>
                            <div className='col-md-3'>
                                <Campo label='Importe'>
                                    <input type='number' className='form-control' value={item.importe} onChange={({ target }) => {
                                        const copia = [...cobros];
                                        copia[index] = { ...copia[index], importe: target.value };
                                        setCobros(copia);
                                    }} />
                                </Campo>
                            </div>
                        </div>
                    ))}
                    <button type='button' className='btn btn-outline-secondary me-2' onClick={() => setCobros([...cobros, { forma_Cobro_Id: '', importe: 0 }])}>Otro cobro</button>
                    <button type='submit' className='btn btn-outline-success'>Cobrar</button>
                </Tarjeta>
            </form>
        </div>
    );
};

export { Cobrar };
